import Vue3Signature from "vue3-signature"

export default function(app) {
  app.use(Vue3Signature)
}